import {Component, effect, inject, signal} from '@angular/core';
import {MenuItem} from "primeng/api";
import {ActivatedRoute, NavigationEnd, Router,} from "@angular/router";
import {filter} from "rxjs";
import {map} from "rxjs/operators";
import {toSignal} from "@angular/core/rxjs-interop";
import {BreadcrumbItemComponent} from "../breadcrumb-item/breadcrumb-item.component";

@Component({
    selector: 'app-breadcrumb',
    imports: [
        BreadcrumbItemComponent
    ],
    templateUrl: './breadcrumb.component.html',
    styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent {
  private activatedRoute = inject(ActivatedRoute)
  private router = inject(Router)

  readonly breadcrumbItems = signal<MenuItem[]>([])

  private routeData = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot.data;
      })
    ),
    { initialValue: {} }
  );

  constructor() {
    effect(() => {
      const data = this.routeData();
      this.breadcrumbItems.set((data as any)['breadcrumbItems'] ?? []);
    });
  }
}
